import { Component, OnDestroy } from '@angular/core';
import { CiamService } from '../../services/ciam.service';
import { Subscription } from 'rxjs';

@Component({
  selector: 'app-auth',
  templateUrl: './auth.component.html',
  styleUrls: ['./auth.component.scss']
})
export class AuthComponent implements OnDestroy {
  loading = true;
  error: string | null = null;
  loginCompleted = false;
  private sub: Subscription;

  constructor(public ciamService: CiamService) {
    console.log('[AuthComponent] Activated callback. Delegating to CiamService.');
    this.sub = this.ciamService.loginCompleted$.subscribe(done => {
      if (done) {
        this.loading = false;
        this.loginCompleted = true;
        if (!this.ciamService.loginSuccess) {
          this.error = 'Authorization failed';
        }
        console.log('[AuthComponent] Login completed. Success:', this.ciamService.loginSuccess);
      }
    });
  }

  ngOnDestroy(): void {
    if (this.sub) {
      this.sub.unsubscribe();
    }
  }
}